import { Pipe, PipeTransform } from '@angular/core';
import { SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'snSanitizeHtml' })
export class SnSanitizeHtmlPipe implements PipeTransform {
  constructor(private readonly _sanitizer: DomSanitizer) {}

  public transform(str: string): SafeHtml {
    // First sanitize the HTML to remove potentially dangerous content
    const sanitizedHtml = this._sanitizer.sanitize(SecurityContext.HTML, str);
    // Then mark it as safe for display
    return this._sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }
}
